import { faSun } from '@fortawesome/free-solid-svg-icons'
import { faMoon } from '@fortawesome/free-solid-svg-icons'
export const lightTheme = {
    body: '#FFF',
    text: '#363537',
    toggleBorder: '#FFF',
    background: '#FFF',
    postBorderColor: '#E2E5E8',
    bannerImg: 'url(https://cdn.danlee.uk/content/assets/bannerLight.jpg)',
    switchIcon: faSun,
}
export const darkTheme = {
    body: '#161618',
    text: '#f6f7f8',
    toggleBorder: '#242529',
    background: '#161618',
    postBorderColor: '#242529',
    bannerImg: 'url(https://cdn.danlee.uk/content/assets/bannerDark.jpg)',
    switchIcon: faMoon,
}